
function logSample() {

    $.get( 'https://your-json-feed.com' , function(data){

        log(data);

        $j.each( data.concerts, function( key, concert ) {

            log(concert);

        });


    });

}

